import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { IconButton, Paper, Stack, Tooltip, Typography } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import type { SearchResultItem } from '@/features/search/types'
import { useAppDispatch } from '@/redux/hooks'
import { setMediaDetailsState } from '../slice'
import { PreviewButtons } from './Buttons'

interface Props {
  openDrawer: boolean
  searchResultItem: SearchResultItem
  url: string
}

export const Preview = (props: Props) => {
  const { openDrawer, searchResultItem, url } = props
  const dispatch = useAppDispatch()
  const location = useLocation()
  const navigate = useNavigate()

  const handleNavigate = () => {
    navigate(`/MediaDetails/${searchResultItem.mediaId}`, {
      state: { from: location.pathname },
    })
    dispatch(setMediaDetailsState({ openDrawer: false }))
  }

  return (
    <Stack gap={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h2">{searchResultItem.title}</Typography>
        {openDrawer && (
          <Tooltip title="Full Screen" placement="bottom">
            <IconButton
              color="secondary"
              size="large"
              onClick={() => handleNavigate()}
            >
              <OpenInNewIcon />
            </IconButton>
          </Tooltip>
        )}
      </Stack>

      <Stack spacing={1}>
        <Typography variant="caption">Preview</Typography>
        <Paper elevation={2}>
          <img
            height="100%"
            width="100%"
            style={{
              objectFit: 'fill',
            }}
            src={url}
            alt={searchResultItem.title || 'Media preview'}
          />
        </Paper>
        <PreviewButtons searchResultItem={searchResultItem} />
      </Stack>
    </Stack>
  )
}
